import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import {
  CHATS,
  CHAT_LIST,
  INDUSTRIALIZATION_REPORTS,
  LOGIN_NOT_SUGGESTS,
  LOGIN_NOT_SUGGESTS_LOG,
  SUGGESTS_APPROVE,
  LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC,
} from 'manager/http-constants';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import { Validator } from 'src/app/shared/validator/validator';
import { CONSTANT, LOADING_KEY } from 'src/app/shared/constant/constant';
import { PlatformComponent } from '../platform.component';
import { ApprovalDialogComponent } from '../common/approval-dialog/approval-dialog.component';
import { DiffTableComponent } from '../common/diff-table/diff-table.component';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { LoginService } from 'src/app/shared/service/login.service';

@Component({
  selector: 'app-c601',
  templateUrl: './c601.component.html',
  styleUrls: ['./c601.component.scss', '../platform.component.scss'],
})

/**
 * 提案詳細
 */
export class C601Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  /** 共通部品_差分比較 */
  @ViewChild(DiffTableComponent)
  diffTableComponent: DiffTableComponent;

  // 画面.チャット入力フォーム
  c601ChatInputForm: FormGroup = this.formBuilder.group({
    // ステータス（課題側判断）
    status_agenda: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'suggest',
          'status_agenda',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // コメント
    chat_comment: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'chat',
          'chat_comment',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  // 画面.意見交換後連携入力フォーム
  c601CooperationInputForm: FormGroup = this.formBuilder.group({
    // 意見交換実施後の連携状況
    questionary1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary1',
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 設問1で（D）連携に至らず終了と回答した場合、その理由を教えて下さい（複数回答可）
    questionary2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary2',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 貴団体において、実現可能性がある提案でしたか？
    questionary3: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary3',
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 提案内容に対して、提案者の熟練度は高いと感じましたか？
    questionary4: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary4',
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 貴団体が想定していた提案と比べて、新規性や意外性がありましたか？
    questionary5: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary5',
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 貴団体の課題解決に、本提案が寄与すると感じましたか？
    questionary6: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary6',
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // 自由記載欄（400文字まで）
    opinion: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'opinion',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  // 画面.アンケート入力フォーム
  c601AnswerInputForm: FormGroup = this.formBuilder.group({
    // 本提案を見送った理由を教えて下さい（複数回答可）
    questionary1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'questionary1',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 自由記載欄（400文字まで）
    opinion: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'industrialization_report',
          'opinion',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  // 提案IDを格納
  suggestId: string = this.route.snapshot.params.suggest_id;

  // 提案詳細格納先
  proposaDetail: any;

  // チャットコメントリスト格納先
  chatCommentList: any;

  // チャットコメントリスト毎秒取得キー
  timerId: any;

  // 課題・ソリューション詳細格納先
  detailTask: any;

  // 課題・ソリューションID
  agendaId: string;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private messageData: MessageData,
    private location: Location,
    private validator: Validator,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  async ngOnInit(): Promise<void> {

    await this.getUserLogin();
    // 辞書値リストを取得
    this.getSpecCodeList(2009, 2010, 2011, 2012, 2013, 2014, 2015, 2022, 2023, 2024);

    // 提案詳細取得
    this.getProposaDetail(true);

    // チャットコメントリスト取得
    this.getChatCommentList();

    // 30秒ごとに動作
    this.timerId = setInterval(() => {
      // 提案詳細取得
      this.getProposaDetail(false);

      // チャットコメントリスト取得
      this.getChatCommentList();
    }, 30000);
  }

  ngOnDestroy(): void {
    // チャット取得を停止
    clearInterval(this.timerId);
  }

  /**
   * 提案詳細取得
   * @param starting 起動回数 true:初回 false:2回目移行
   */
  public getProposaDetail(starting?: boolean): void {
    // 起動回数の判定
    if (starting) {
      // 初回起動の場合
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(LOGIN_NOT_SUGGESTS);
    }

    // 提案詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(LOGIN_NOT_SUGGESTS, this.suggestId)
      .subscribe((response) => {
        // 起動回数の判定
        if (starting) {
          // 初回起動の場合
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_SUGGESTS);
        }

        if (this.commonService.checkNoneResponse(response)) {
            // 異常メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
                position: TOAST.BOTTOM_RIGHT,
                life: 60000,
              })
            );
            this.loginService.logout(MESSAGE_CODE.N90001);
            return;
        } else {
          // 提案詳細を格納
          this.proposaDetail = response.body[0];
          this.agendaId = this.proposaDetail.agenda_id;
          this.getDetailTask(starting);

          // 課題記載した会員IDか否か
          if (this.decisionPerspective(this.proposaDetail.member_id_agenda) || this.decisionSecretariat()) {
            //  課題記載した会員IDの場合

            // 起動回数の判定
            if (starting) {
              // 初回起動の場合

              // 事業化報告アンケート初期表示を実施
              this.setEditInitialData(this.proposaDetail.status_agenda.id);
            }
          }
        }
      });
  }

  /**
   * 課題・ソリューション詳細(C301)へ遷移する
   */
  public moveC301(): void {
    // 課題・ソリューション詳細(C301)へ遷移
    this.router.navigate([
      'pages/platform/c301/' + this.proposaDetail.agenda_id,
    ]);
  }

  /**
   * 提案登録(C401)へ遷移する
   */
  public moveC401(): void {
    // 提案登録(C401)へ遷移
    this.router.navigate(['pages/platform/c401/edit'], {
      queryParams: {
        screenId: 'c401',
        agenda_id: this.proposaDetail.agenda_id,
        suggest_id: this.suggestId,
      },
    });
  }

  /**
   * チャットコメントリスト取得
   */
  public getChatCommentList(): void {
    // チャットコメントリストを取得
    this.dbOperationService
      .getNoTemplateData(CHAT_LIST, { suggest_id: this.suggestId }, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // カテゴリリストを格納
          this.chatCommentList = response.body;
        } else {
          this.chatCommentList = new Array();
        }
      });
  }

  /**
   * チャットコメントセット
   * @param value 選択値
   */
  public setChatComment(value: string): void {
    // 初期チャットコメント格納先
    let initialChatComment: string;

    switch (value) {
      case '1':
        initialChatComment = 'ご提案ありがとうございます。\r\n現在､検討中です｡';
        break;
      case '2':
        initialChatComment =
          'ご提案ありがとうございます。\r\n他の提案を採用することになったため、今回の提案は見送りとさせていただきます。';
        break;
      case '3':
        initialChatComment =
          'ご提案ありがとうございます。\r\n検討の結果、今回の提案は見送りとさせていただきます。';
        break;
      case '4':
        initialChatComment =
          'ご提案ありがとうございます。\r\n今回の提案は見送りとさせていただきます。';
        break;
      case '5':
        initialChatComment =
          'ご提案ありがとうございます。\r\n直接、意見交換させていただきたいため、\r\n下記の連絡先へご連絡ください｡\r\n担当:\r\nメール:\r\n電話番号:';
        break;
      default:
        initialChatComment = CONSTANT.EMPTY_STRING;
        break;
    }

    // チャットコメントにセット
    this.c601ChatInputForm.get('chat_comment').setValue(initialChatComment);
  }

  /**
   * チャットコメントセット(依頼用)
   * @param value 選択値
   */
   public setChatCommentRequest(value: string): void {
    // 初期チャットコメント格納先
    let initialChatComment: string;

    switch (value) {
      case '1':
        initialChatComment = 'ご依頼ありがとうございます。\r\n現在､検討中です｡';
        break;
      case '2':
        initialChatComment =
          'ご依頼を検討させて頂きましたが、貴団体のご要望に沿う提案が難しいため、今回は辞退させていただきます。';
        break;
      case '3':
        initialChatComment =
          'ご依頼ありがとうございます。\r\n今回の依頼は見送りとさせていただきます。';
        break;
      case '5':
        initialChatComment =
          'ご依頼ありがとうございます。\r\n直接、意見交換させていただきたいため、\r\n下記の連絡先へご連絡ください。\r\n担当:\r\nメール:\r\n電話番号:';
        break;
      default:
        initialChatComment = CONSTANT.EMPTY_STRING;
        break;
    }

    // チャットコメントにセット
    this.c601ChatInputForm.get('chat_comment').setValue(initialChatComment);
  }

  /**
   * チャット登録処理
   */
  public onChatInsert(): void {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      }),
      CHATS
    );

    // 画面.チャット入力フォームから入力内容を取得
    // ※値渡し
    let c601ChatInputForm: any = JSON.parse(
      JSON.stringify(this.c601ChatInputForm.value)
    );

    // 提案ID
    c601ChatInputForm.suggest_id = this.suggestId;

    // チャット登録を実施
    this.dbOperationService
      .insertData(CHATS, c601ChatInputForm)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, CHATS);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS != response.body.Message) {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E90003),
            })
          );
        }

        // チャット入力値を初期化
        this.c601ChatInputForm.reset();

        // 提案詳細取得
        this.getProposaDetail(false);

        // チャットコメントリスト取得
        this.getChatCommentList();
      });
  }

  /**
   * 非公開掲示板のページアンカーにスクロール
   */
  public jumpChatTop(): void {
    // ステータス（課題側判断）が5:意見交換希望か否か
    // 課題記載した会員IDか否か
    if (
      5 == this.proposaDetail.status_agenda.id &&
      this.decisionPerspective(this.proposaDetail.member_id_agenda)
    ) {
      // ステータス（課題側判断）が5:意見交換希望の場合 かつ
      //  課題記載した会員IDの場合

      let jumpChatTop = document.getElementById('jump-exchange-of-opinions');
      jumpChatTop.scrollIntoView();
      jumpChatTop = null;
    } else {
      // 上記以外

      let jumpChatTop = document.getElementById('jump-chat-top');
      jumpChatTop.scrollIntoView();
      jumpChatTop = null;
    }
  }

  /**
   * 事業化報告アンケート初期表示
   * @param ステータス（課題側判断）
   */
  private setEditInitialData(statusAgenda: number) {
    // ステータス（課題側判断）を判定
    if (1 == statusAgenda) {
      // 1:検討中の場合

      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(INDUSTRIALIZATION_REPORTS);

    // 課題・ソリューション詳細を取得
    this.dbOperationService
      .getNoTemplateData(INDUSTRIALIZATION_REPORTS, {
        suggest_id: this.suggestId,
        status_agenda: statusAgenda,
      })
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, INDUSTRIALIZATION_REPORTS);

        if (this.commonService.checkNoneResponse(response)) {
          return;
        }

        // ステータス（課題側判断）を判定
        if (5 == statusAgenda) {
          // 5:意見交換希望

          // 初期値セット
          this.commonService.setFormGroupInitialData(
            this.c601CooperationInputForm,
            response.body
          );
        } else {
          // 2:見送り（理由１） 3:見送り（理由２） 4:見送り（理由３）の場合

          // 初期値セット
          this.commonService.setFormGroupInitialData(
            this.c601AnswerInputForm,
            response.body
          );
        }
      });
  }

  /**
   * 事業化報告アンケート登録処理
   * @param industrializationReportKbn アンケート区分(1:事業化報告 2:見送り)
   */
  public insertIndustrializationReport(industrializationReportKbn: number) {
    // 入力フォーム情報格納先
    let c601InputForm: any;

    if (1 == industrializationReportKbn) {
      // 画面.意見交換後連携入力フォームから入力内容を取得
      // ※値渡し
      c601InputForm = JSON.parse(
        JSON.stringify(this.c601CooperationInputForm.value)
      );

      // 配列をカンマ区切り変換
      c601InputForm.questionary2 = c601InputForm.questionary2.toString();
    } else {
      // 画面.アンケート入力フォームから入力内容を取得
      // ※値渡し
      c601InputForm = JSON.parse(
        JSON.stringify(this.c601AnswerInputForm.value)
      );

      // 配列をカンマ区切り変換
      c601InputForm.questionary1 = c601InputForm.questionary1.toString();
    }

    // 提案IDをセット
    c601InputForm.suggest_id = this.suggestId;

    // アンケート区分をセット
    c601InputForm.industrialization_report_kbn = industrializationReportKbn;

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 事業化報告レポート登録を実施
    this.dbOperationService
      .insertData(INDUSTRIALIZATION_REPORTS, c601InputForm)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合

          // 正常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.SUCCESS,
              summary: this.commonService.msg(MESSAGE_CODE.T00001),
              detail: this.commonService.msg(MESSAGE_CODE.I00001),
            })
          );
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E90003),
            })
          );
        }
      });
  }

  /**
   * 内閣府承認ダイアログ表示
   */
  public openSmallApprovalDialog(): void {
    // 内閣府承認ダイアログ表示
    this.approvalDialogComponent.openSmallApprovalDialog(
      SUGGESTS_APPROVE,
      this.suggestId,
      2004,
      0,
      1
    );
  }

 /**
  * 差分ダイアログ表示
  */
  public openDiffDialog(screen_id: string): void {
    // 差分比較ダイアログ表示
    this.diffTableComponent.openDiffTable(
      screen_id,
      LOGIN_NOT_SUGGESTS,
      LOGIN_NOT_SUGGESTS_LOG,
      this.suggestId,
      2004,
      0,
      1
    );
  }

  /**
   * 数値を英語に変換
   */
  public numberChangeEnglish(number: number): string {
    let englishString: string = CONSTANT.EMPTY_STRING;

    switch (number) {
      case 0:
        englishString = 'A';
        break;
      case 1:
        englishString = 'B';
        break;
      case 2:
        englishString = 'C';
        break;
      case 3:
        englishString = 'D';
        break;
      case 4:
        englishString = 'E';
        break;
      case 5:
        englishString = 'F';
        break;
      case 6:
        englishString = 'G';
        break;
      case 7:
        englishString = 'H';
        break;
      case 8:
        englishString = 'I';
        break;
      case 9:
        englishString = 'J';
        break;
      default:
        englishString = CONSTANT.EMPTY_STRING;
        break;
    }

    return englishString;
  }

  /**
   * 課題・ソリューション詳細を取得
   * @param starting 起動回数 true:初回 false:2回目移行
   */
  public getDetailTask(starting?: boolean): void {
    // 起動回数の判定
    if (starting) {
      // 初回起動の場合
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);
    }

    // 課題・ソリューション詳細を取得
    this.dbOperationService
    .getNoTemplateDisplayData(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC, this.agendaId)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          if(!(
            this.decisionPerspective(this.proposaDetail.member_id)||
            (this.decisionPerspective(response.body[0].member_id) && this.proposaDetail.status.id == '2') ||
            this.decisionSecretariat())
          ){
            // 異常メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
                position: TOAST.BOTTOM_RIGHT,
                life: 60000,
              })
            );
            this.loginService.logout(MESSAGE_CODE.N90001);
            return;
          }

          // 課題・ソリューション詳細を格納
          this.detailTask = response.body[0];
          
          if(1 == this.detailTask.agenda_kbn.id){
            sessionStorage.setItem('suggestOrRequest', 'suggest')
          } else {
            sessionStorage.setItem('suggestOrRequest', 'request')
          }
        }
      });
  }
  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });
  }
}
